/* eslint-disable no-debugger */
/* cSpell:disable */
import RegisterPharmacyActionTypes, {
	RegisterPharmacyState,
	UserData,
	StepRegisterInputData,
	RegisterInputData,
} from './types';
import { AnyAction } from 'redux';
import { EnrollmentTypes } from '@api/ff-shared-services-api';

export const initialRegisterPharmacyState: RegisterPharmacyState = {
	externalId: '',
	configs: {
		products: [],
	},
	registerInputData: {
		nipc: '',
		entityName: '',
		address: '',
		postalCodePrefix: '',
		postalCodeSuffix: '',
		locality: '',
		preferredContactName: '',
		preferredContactEmail: '',
		preferredContactPhonePrefix: '',
		preferredContactPhoneNumber: '',
		subscription: undefined,
		permanentCertificateCode: '',
		ibanNumber: '',
		ibanInputFile: undefined,
		proofInputFile: undefined,
		usersData: [],
	},
};
const reducer: (state: RegisterPharmacyState | undefined, action: AnyAction) => RegisterPharmacyState = (
	state = initialRegisterPharmacyState,
	action
): RegisterPharmacyState => {
	switch (action.type) {
		case RegisterPharmacyActionTypes.SAVE_REGISTER_INPUT_DATA: {
			const payloadData = action.payload as StepRegisterInputData;
			const registerInputData = payloadData.registerInputData as RegisterInputData;

			/* MOCK_DATA - START */
			// eslint-disable-next-line sonarjs/no-small-switch
			// switch (payloadData.stepIndex) {
			// 	case 1:
			// 		action.payload = {
			// 			registerInputData: {
			// 				nipc: '506985512',
			// 				entityName: 'Nelson',
			// 				address: 'Rua dos dfdf - N°15 - fdffd',
			// 				postalCodePrefix: '3040',
			// 				postalCodeSuffix: '778',
			// 				locality: 'Braga',
			// 				preferredContactName: 'Nelson Barbosa',
			// 				preferredContactEmail: 'dfdfdfdf@hotmail.com',
			// 				preferredContactPhonePrefix: '+351',
			// 				preferredContactPhoneNumber: '9184256119',
			// 				subscription: 'oneSubscription',
			// 				typePermanentCertificate: 'code',
			// 				permanentCertificateCode: '123456789',
			// 			},
			// 		};
			// 		break;

			// 	case 2:
			// 		action.payload = {
			// 			registerInputData: {
			// 				registerInputData: { ibanNumber: 'PT50 0002 0123 1234 5678 9015 4' },
			// 				stepIndex: 2,
			// 			},
			// 		};
			// 		break;
			// }
			/* MOCK_DATA - END */

			let newData: RegisterInputData = {}; // = { ...initialRegisterPharmacyState.registerInputData };

			switch (payloadData.stepIndex) {
				case 1:
					newData = {
						...state.registerInputData,
						...{
							nipc: registerInputData.nipc,
							entityName: registerInputData.entityName,
							address: registerInputData.address,
							postalCodePrefix: registerInputData.postalCodePrefix,
							postalCodeSuffix: registerInputData.postalCodeSuffix,
							locality: registerInputData.locality,
							preferredContactName: registerInputData.preferredContactName,
							preferredContactEmail: registerInputData.preferredContactEmail,
							preferredContactPhonePrefix: registerInputData.preferredContactPhonePrefix,
							preferredContactPhoneNumber: registerInputData.preferredContactPhoneNumber,
							subscription: registerInputData.subscription,
							typePermanentCertificate: registerInputData.typePermanentCertificate,
							permanentCertificateCode: registerInputData.permanentCertificateCode,
							proofInputFile: state.registerInputData.proofInputFile,
						},
					};

					// newData = {
					// 	...newData,
					// 	...{
					// 		nipc: registerInputData.nipc,
					// 		entityName: payloadData.registerInputData.entityName,
					// 		address: payloadData.registerInputData.address,
					// 		postalCodePrefix: payloadData.registerInputData.postalCodePrefix,
					// 		postalCodeSuffix: payloadData.registerInputData.postalCodeSuffix,
					// 		locality: payloadData.registerInputData.locality,
					// 		preferredContactName: payloadData.registerInputData.preferredContactName,
					// 		preferredContactEmail: payloadData.registerInputData.preferredContactEmail,
					// 		preferredContactPhonePrefix: payloadData.registerInputData.preferredContactPhonePrefix,
					// 		preferredContactPhoneNumber: payloadData.registerInputData.preferredContactPhoneNumber,
					// 		subscription: payloadData.registerInputData.subscription,
					// 		typePermanentCertificate: payloadData.registerInputData.typePermanentCertificate,
					// 		permanentCertificateCode: payloadData.registerInputData.permanentCertificateCode,
					// 		proofInputFile: state.registerInputData.proofInputFile,
					// 	},
					// 	...{
					// 		ibanNumber: state.registerInputData.ibanNumber,
					// 		ibanInputFile: state.registerInputData.ibanInputFile,
					// 	},
					// };
					break;

				case 2:
					newData = {
						...state.registerInputData,
						ibanNumber: registerInputData.ibanNumber,
					};
					break;
				case 3:
				case 4:
					newData = {
						...state.registerInputData,
						...registerInputData,
					};
					break;
			}

			return {
				...state,
				registerInputData: newData,
			};
		}
		case RegisterPharmacyActionTypes.SAVE_USER_DATA: {
			return {
				...state,
				registerInputData: {
					...state.registerInputData,
					usersData: state.registerInputData.usersData && [
						...state.registerInputData.usersData,
						{ ...action.payload },
					],
				},
			};
		}
		case RegisterPharmacyActionTypes.UPDATE_USER_DATA: {
			return {
				...state,
				registerInputData: {
					...state.registerInputData,
					usersData: state.registerInputData.usersData && [
						...state.registerInputData.usersData.map(u => {
							// if (u.idDocumentNumber === (action.payload as UserData).idDocumentNumber)
							if (u.id === (action.payload as UserData).id)
								return {
									...u,
									...(action.payload as UserData),
								};
							return u;
						}),
					],
				},
			};
		}
		case RegisterPharmacyActionTypes.REMOVE_USER_DATA: {
			// const usersData: UserData[] = state.registerInputData.usersData
			// 	? state.registerInputData.usersData.filter(x => x.idDocumentNumber !== action.payload)
			// 	: [];

			//debugger;
			const usersData: UserData[] = state.registerInputData.usersData
				? state.registerInputData.usersData.filter(x => x.id !== action.payload)
				: [];

			//debugger;
			return {
				...state,
				registerInputData: {
					...state.registerInputData,
					usersData: usersData,
				},
			};
		}
		case RegisterPharmacyActionTypes.FETCH_CONFIGURATIONS_SUCCESS: {
			return {
				...state,
				configs: {
					...state.configs,
					...action.payload,
				},
			};
		}
		case RegisterPharmacyActionTypes.FETCH_UPLOAD_FILE_EXECUTION_REQUEST: {
			return state;
		}
		case RegisterPharmacyActionTypes.FETCH_ADD_REGISTER_DATA_SUCCESS: {
			return {
				...state,
				externalId: action.payload as string,
			};
		}
		case RegisterPharmacyActionTypes.FETCH_UPLOAD_FILE_EXECUTION_SUCCESS: {
			switch (action.payload.inputType) {
				case EnrollmentTypes.EnrollmentDocumentDocumentType.CERT_PERM_DOC:
					return {
						...state,
						registerInputData: {
							...state.registerInputData,
							proofInputFile: action.payload,
						},
					};
				case EnrollmentTypes.EnrollmentDocumentDocumentType.IBAN:
					return {
						...state,
						registerInputData: {
							...state.registerInputData,
							ibanInputFile: action.payload,
						},
					};
				case EnrollmentTypes.EnrollmentDocumentDocumentType.CONTRACT:
					return {
						...state,
						registerInputData: {
							...state.registerInputData,
							contractInputFile: action.payload,
						},
					};
				default: {
					return state;
				}
			}
		}
		case RegisterPharmacyActionTypes.REMOVE_UPLOAD_FILE_EXECUTION: {
			switch (action.payload.inputType) {
				case EnrollmentTypes.EnrollmentDocumentDocumentType.CERT_PERM_DOC:
					return {
						...state,
						registerInputData: {
							...state.registerInputData,
							proofInputFile: undefined,
						},
					};
				case EnrollmentTypes.EnrollmentDocumentDocumentType.IBAN:
					return {
						...state,
						registerInputData: {
							...state.registerInputData,
							ibanInputFile: undefined,
						},
					};
				case EnrollmentTypes.EnrollmentDocumentDocumentType.CONTRACT:
					return {
						...state,
						registerInputData: {
							...state.registerInputData,
							contractInputFile: undefined,
						},
					};
				default: {
					return state;
				}
			}
		}
		case RegisterPharmacyActionTypes.FETCH_UPLOAD_FILE_EXECUTION_ERROR:
		default: {
			return state;
		}
	}
};
export { reducer as registerPharmacyReducer };
